/**
 * Shared React Query client.
 *
 * Conservative defaults for an admin SPA:
 *   - 30s stale time — most admin data tolerates this; printer status uses
 *     a per-query refetchInterval (5s) for liveness.
 *   - 1 retry on failure — avoid hammering broken endpoints during outages.
 *   - refetchOnWindowFocus = true — when an admin tabs back, refresh.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
